import { CaseViewResponse } from './model';
import { DetailsCaseActionTypes } from './types';
import { createAction } from 'typesafe-actions';

export const fetchCaseView = createAction(
    DetailsCaseActionTypes.FETCH_CASE_VIEW,
    (instructionId: number) => ({ instructionId })
  )();
  
  export const fetchCaseViewSuccess = createAction(
    DetailsCaseActionTypes.FETCH_CASE_VIEW_SUCCESS,
    (caseView: CaseViewResponse) => caseView
  )();
  
  export const fetchCaseViewError = createAction(
    DetailsCaseActionTypes.FETCH_CASE_VIEW_FAIL,
    (code: string, message: string) => ({ code, message })
  )();
  
  export const resetDetailsCaseState = createAction(
    DetailsCaseActionTypes.RESET_STATE
  )();
